export default {
  'component.tagSelect.expand': 'توسيع',
  'component.tagSelect.collapse': 'طي',
  'component.tagSelect.all': 'الكل',
  'component.menuSearch.placeholder': 'بحث في القائمة',
  'component.menuSearch.empty': 'لا توجد صفحات مطابقة',
};
